export default "__VITE_ASSET__CiLnTmfp__"